<template>
  <div class="yui-wrap-box">
    <el-row>
      <el-col :span="24">
        <div class="wrap-title" @click="toggle()" :class="{pointer:isExpand}">
          <i :class="isShow?'el-icon-caret-bottom':'el-icon-caret-right'"></i>
          {{name}}
        </div>
      </el-col>
      <el-col :span="24" class="wrap-body" v-show="isShow">
        <slot></slot>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'bopWrap',
    data () {
      return {
        isShow: this.expandState
      }
    },
    props: {
      name: String,
      expandState: {
        type: Boolean,
        default: true
      },
      isExpand: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      toggle () {
        if (!this.isExpand) return
        this.isShow = !this.isShow
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../components/wrap/config.scss';
  .yui-wrap-box{
    .wrap-title{
      font-size: $small-font;
      border-radius: 2px;
      margin: 10px 0;
      background: linear-gradient(#fff,#eeeff5)!important;
      box-shadow: rgba(102, 102, 102, 0.2) 1px 2px 1px 0px, rgba(102, 102, 102, 0.2) -1px -1px 1px 0px;
      height: $primary-height;
      line-height: $primary-height;
      padding-left: 12px;
      font-size: $large-font;
      color: $primary-text-color;
      i{
        margin-right: 3px;
        font-size: 15px;
      }
    }
    .wrap-body{
      margin-bottom: $primary-distance;
    }
    .pointer{
      cursor:pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/wrap/index.vue